import React from 'react';
import { Card, Text, Group, rem, Box, useMantineTheme } from '@mantine/core';

const StatCard = ({ title, value, icon: Icon, color }) => {
  const theme = useMantineTheme();
  
  // Helper to map MUI-style color string to Mantine palette color
  const getColor = (c) => {
    switch (c) {
      case '#1976d2': return theme.colors.blue[8]; // Blue
      case '#d32f2f': return theme.colors.red[8]; // Red
      case '#ed6c02': return theme.colors.orange[6]; // Orange
      case '#2e7d32': return theme.colors.green[8]; // Your Primary Green
      default: return theme.colors.gray[6];
    }
  };
  
  const mantineColor = getColor(color);

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder h={rem(100)}>
      <Group justify="space-between" align="flex-start" h="100%">
          <Box>
              <Text fz="xs" c="dimmed">
                  {title}
              </Text>
              <Text fz="xl" fw={700} c={mantineColor} mt={4}>
                  {value}
              </Text>
          </Box>
          {Icon && <Icon style={{ width: rem(32), height: rem(32) }} color={mantineColor} />}
      </Group>
    </Card>
  );
};

export default StatCard;